<template>
    <mc-cascader
        v-model="innerValue"
        class="cascader"
        :data="wmCategoryList"
        placeholder="请选择品类"
        filterable
        :disabled="disabled"
        :props="{
            label: 'label',
            value: 'id',
            children: 'children'
        }"
        @change="handleChange"
    />
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { hPost } from '@mcfe/tools';

export default {
    name: 'WmCategorySelect',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const wmCategoryList = ref([]);
        const copyWmCategoryList = ref([]);

        const mergeLevel = (arr) => {
            // 合并相同类目id的父级
            const result = [];
            arr.forEach((item) => {
                const existingItem = result.find((existing) => existing.id === item.id);
                if (existingItem && item.children) {
                    item.children.forEach((child) => {
                        const existingChild = existingItem.children.find((c) => c.id === child.id);
                        if (existingChild?.children && existingChild.children?.length && child.children) {
                            existingChild.children = mergeLevel([...existingChild.children, ...child.children]);
                        } else if (!existingChild && child.children) {
                            existingItem.children.push(child);
                        }
                    });
                } else if (!existingItem && item.children) {
                    result.push(item);
                }
            });
            return result;
        };

        // 请求美团外卖类目
        const queryWmBgCategory = async () => {
            try {
                const res = await hPost('/api/vss/shepherd/VssInternalChannelSkuTService/queryChannelAllLeafBgCategory', { channelId: 4 });
                copyWmCategoryList.value = res.wmChannelBgCategories
                    || [];

                const wmBgCategories = (res.wmChannelBgCategories || []).map((item) => {
                    const idArr = item.idPath.split(',').filter(Boolean);
                    const labelArr = item.namePath.split(',').filter(Boolean);

                    const children = [];
                    const newItem = { id: +idArr[0], label: labelArr[0], children };
                    let parent = newItem;
                    for (let i = 0; i < idArr.length - 1; i++) {
                        const id = idArr[i + 1];
                        const label = labelArr[i + 1];
                        const child = parent.children.find((items) => items.id === id);
                        if (child) {
                            parent = child;
                        } else {
                            const newChild = { id: Number(id), label, children: [] };
                            parent.children.push(newChild);
                            parent = newChild;
                        }
                    }
                    return newItem;
                });
                wmCategoryList.value = mergeLevel(wmBgCategories);
            } catch (err) {
                console.error('获取美团外卖类目失败', err);
            }
        };

        // 定义一个方法，用于匹配美团外卖类目
        const mateWmCategory = (bgCategoryId) => (copyWmCategoryList.value || []).find((item) => item.id === bgCategoryId);

        const innerValue = computed({
            get() {
                return mateWmCategory(props.value)?.idPath.split(',').filter(Boolean).map((item) => Number(item));
            },
            set(val) {
                emit('input', val[val.length - 1]);
            },
        });

        // 类目change
        const handleChange = (val) => {
            emit('change', val);
        };

        // 调用方法，请求获取所有的美团外卖类目
        queryWmBgCategory();

        return {
            wmCategoryList,
            innerValue,
            handleChange,
            mateWmCategory,
        };
    },
};
</script>

<style lang="scss" scoped>
.cascader {
    width: 400px;
}
</style>
